<template>
  <div class="cs_container customerServiceMb">
    <div class="main-content">
      <div class="address-text">
        <p>admin@shopafm.com</p>
        <p>{{ $t('wechat') }} ID：SHOPAFM</p>
        <p>425-357-2992</p>
        <p>{{ $t('days_a_week') }}</p>
        <p>10am--7pm</p>
      </div>
      <div class="social-icons">
        <img class="icon" src="../../assets/img/weChatIcon.svg"/>
        <img class="icon" src="../../assets/img/instagramIcon.svg"/>
        <img class="icon" src="../../assets/img/facebookIcon.svg"/>
      </div>
      <div v-show="postContactSuccess" class="contact-success">
        Contact Form Submitted!
      </div>
        <div class="help-form" v-show="!postContactSuccess">
          <div class="input-item">
            <p class="input-title">{{ $t('name') }}</p>
            <input class="input-box" :placeholder="$t('name')" v-model="form.Name" @keyup="checkForm"/>
            <span v-if="error.Name" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.Name}}
            </span>
          </div>
            <div class="input-item">
              <p class="input-title">{{ $t('email') }}</p>
              <input class="input-box" :placeholder="$t('email')" v-model="form.Email" @keyup="checkForm"/>
                <span v-if="error.Email" class='error-message'>
                  <svg class="icon icon-error">
                    <path
                      d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
                  </svg>
                  {{error.Email}}
                </span>
            </div>
            <div class="input-item">
              <p class="input-title">{{$t('phone_optional')}}</p>
              <input class="input-box" placeholder="(000)-000-0000" v-model="form.PhoneNumber" @keyup="checkForm"
            />
            <span v-if="error.PhoneNumber" class='error-message'>
              <svg class="icon icon-error">
                <path
                  d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
              </svg>
              {{error.PhoneNumber}}
            </span>
            </div>
          <div class="input-item">
            <p class="input-title">{{ $t('message') }}</p>
            <input
              class="input-box"
              :placeholder="$t('message')"
              v-model="form.Message"
              @keyup="checkForm"
          />
          <span v-if="error.Message" class='error-message'>
            <svg class="icon icon-error">
              <path
                d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm-1.05-3.85A1.05 1.05 0 1 1 7 11.2a1.008 1.008 0 0 1-1.05-1.05zm.381-1.981l-.266-5.25h1.841l-.255 5.25h-1.32z"></path>
            </svg>
            {{error.Message}}
          </span>
          </div>
          <div class="button-cont">
            <button @click="sendContactUsForm($event)">{{$t('send')}}!</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { validateEmail, validatePhoneNumber } from "../../../config/validation";

export default {
  name: "customerService",
  data(){
    return{
      form: {
        Name: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
      error:{
        Name: '',
        Email: '',
        PhoneNumber: '',
        Message: '',
      },
    }
  },
  methods:{
    ...mapActions('contact', ['postContact']),
    ...mapMutations('contact', ['resetPostContact']),
    async checkForm() {
      if (!this.form.Name){
        this.error.Name = 'Name cannot be empty.'
      } else {
        this.error.Name = '';
      }
      if (validateEmail(this.form.Email)){
        this.error.Email = 'Email is invalid.'
      } else {
        this.error.Email = '';
      }
      if (!this.form.Message) {
        this.error.Message = 'Message cannot be empty.'
      } else {
         this.error.Message = '';
      }
      if (validatePhoneNumber(this.form.PhoneNumber)) {
        this.error.PhoneNumber = 'Phone Number is invalid.'
      } else {
        this.error.PhoneNumber = '';
      }
    },
    sendContactUsForm(e) {
      e.preventDefault();
      this.submit = false;
      if (!this.error.Name && !this.error.Email && !this.error.PhoneNumber && !this.error.Message) {
        this.postContact(this.form)
      }
    },
  },
  mounted() {
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    postContactSuccess: state => state.contact.postContactSuccess,
  }),
  watch: {
    postContactSuccess(newValue, oldValue) {
      if (newValue == true) {
        let that = this;
        this.submit = true;
        this.form.Name = '';
        this.form.Email = '';
        this.form.PhoneNumber = '';
        this.form.Message = '';
        setTimeout(function(){
          that.resetPostContact(false)
        }, 3000);

      }
    },
  }
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/customerService.vue